<template>
  <div class="edit-pro-name-box">
    <header-back
      :title="editProTit"
      @back="resetHandler"
    />
    <cube-form
      :model="model"
      @validate="validateHandler"
      @submit.prevent="submitHandler"
      @reset="resetHandler"
    >
      <cube-form-item>
        <div class="cube-form-tip-box">
          <h3>{{ $t('message["1586"]') }}  {{ this.$route.query.projectname }}</h3>
          <p>{{ $t('message["1400"]') }}？</p>
        </div>
      </cube-form-item>
      <div class="pro-name-count">
        <cube-form-item :field="fields[0]" />
        <em>{{ model.projectname ? (20-model.projectname.length) : 20 }}</em>
      </div>
      <!-- <cube-form-item class="leader-tip-box">
        {{ $t('message["331"]') }}
      </cube-form-item> -->
      <div class="form-btn-box">
        <cube-button
          :light="true"
          type="reset"
        >
          {{ $t('message["896"]') }}
        </cube-button>
        <cube-button
          type="submit"
          :primary="true"
        >
          {{ $t('message["915"]') }}
        </cube-button>
      </div>
    </cube-form>
  </div>
</template>
<script>
import HeaderBack from '@/components/mobile/HeaderBack'
import { mapActions } from 'vuex'
export default {
  components: {
    HeaderBack
  },
  data () {
    return {
      validity: {},
      valid: undefined,
      model: {
        projectname: this.$route.query.projectname
      },
      options: {
        scrollToInvalidField: true,
        layout: 'fresh' // classic fresh
      },
      fields: [
        {
          type: 'input',
          modelKey: 'projectname',
          label: this.$t('message["1325"]'),
          props: {
            placeholder: this.$t('message["814"]'),
            maxlength: 20
          },
          rules: {
            required: true
          }
        }
      ]
    }
  },
  computed: {
    editProTit () {
      return this.$t('message["1398"]')
    },
    type () {
      const { type = 'inquery' } = this.$route.query
      return type
    }
  },
  mounted () {
  },
  methods: {
    ...mapActions('organization/org', ['ajaxEditPro']),
    async submitHandler (e) {
      let obj = {}
      const { type } = this
      const chain = await this.ajaxEditPro({ cid: this.$route.query.cid })
      obj = Object.assign(this.model, { cid: this.$route.query.cid, projectid: this.$route.query.projectid, pType: type === 'inquery' ? 1 : 2 })
      chain.params(obj)
        .onSuccess(raw => {
          this.$router.push({
            name: 'ProjectIndexPc',
            query: {
              page: 2,
              cid: this.$route.query.cid,
              type
            } })
        })
        .onNetSuccess((res) => {
          const toast = this.$createToast({
            time: 2000,
            txt: res.data.message || res.data.payload[0].message,
            type: 'txt'
          })
          toast.show()
        })
        .config({ tip: false })
        .fetch()
    },
    validateHandler (result) {
      this.validity = result.validity
      this.valid = result.valid
    },
    resetHandler () {
      this.$router.push({
        name: 'ProjectIndexPc',
        query: {
          page: 2,
          cid: this.$route.query.cid,
          type: this.type
        } })
    }
  }
}
</script>
<style lang="scss" scoped>
.edit-pro-name-box::v-deep {
  .leader-tip-box {
    background: rgba(0,0,0,0.08);
    color: #b2b2b2;
    font-size: 16px;
    // opacity: 0.02;
    // filter: alpha(opacity=2)
    text-align: center;
    span{
      margin:0 30px 0 6px;
    }
  }
  .cube-form-item {
      line-height: 56px;
      min-height: 56px;
    }
  .cube-form-label,.cube-form-field,.cube-input-field{
    font-size: 16px;
  }
  .cube-form-field {
    span {
      margin-right: 43px;
    }
  }
}
.pro-name-count {
    position: relative;
    em {
      position: absolute;
      font-style: normal;
      right: 10px;
      top: 17px;
      color: #999;
    }
  }
  .cube-form-tip-box {
    p{
      white-space: nowrap;
    }
  }
</style>
